import storage from '@/helpers/storage'
import session from '@/helpers/session'
import STORAGE from '@/constants/storage'

import Vue from 'vue'

import merge from 'merge'
// import get from 'get-object'

const defaultOptions = {
  use: ['request', 'response']
}

export default function (client, options) {
  const opts = merge(defaultOptions, options)

  const interceptors = {
    request: {
      success (config) {
        if (config.url.match(/anonymity\/login|public\/v1\/oauth\/login/)) return config
        config.headers.token = session.get(STORAGE.LOGIN_TOKEN) || storage.get(STORAGE.LOGIN_TOKEN)
        config.headers.clienttype = config.headers.clienttype || 'WEB'
        config.headers.platform = 'GROOT'
        return config
      },
      error (e) {
        return Promise.reject(e)
      }
    },
    response: {
      async success (res) {
        // code === 99999, refresh 失效, 自动重新登录
        if (res.status === 200 && res.data.code === 99999) {
          const loginRes = await Vue.prototype.$authApi.login.anonymityLogin()
          if (loginRes && loginRes.token) {
            session.set(STORAGE.LOGIN_TOKEN, loginRes.token)
            res.config.headers.token = loginRes.token
            // 防止login和refresh循环调用
            if (res.config.url.match('/public/v1/refresh')) {
              res.data.code = 0
              res.data.message = '请求成功'
              res.data.data = loginRes
              return res
            }
            return client(res.config)
          }
        }
        return res
      },
      async error (e) {
        const res = e.response
        // status === 401，token 失效，需要用refresh 换取新的token
        if (res.status === 401) {
          const refreshToken = storage.get(STORAGE.LOGIN_REFRESH)
          const data = await Vue.prototype.$authApi.login.refresh(refreshToken)
          if (data && data.token) {
            // 新的 token 配置 headers 并重新请求
            storage.set(STORAGE.LOGIN_TOKEN, data.token)
            session.set(STORAGE.LOGIN_TOKEN, data.token)

            storage.set(STORAGE.LOGIN_REFRESH, data.refresh)
            res.config.headers.token = data.token
            return client(res.config)
          }
        }
        return Promise.reject(e)
      }
    }
  }

  opts.use.forEach(use => {
    client.interceptors[use].use(interceptors[use].success, interceptors[use].error)
  })

  return client
}



// WEBPACK FOOTER //
// ./src/apis/interceptors/auth.js